import React from 'react';
import classNames from 'classnames';
import { ChevronIcon } from 'twain-sport-fe-mono/icons';
import { TwainGameId } from 'betgames-contract-js';
import { ChevronDirection } from 'twain-sport-fe-mono/icons/ChevronIcon';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { ISelectOption } from './interfaces';
import classes from './Select.module.scss';

interface IProps {
    id?: string;
    options: ISelectOption[];
    value?: ISelectOption['value'];
    onChange(value: ISelectOption['value']): void;
    className?: string;
    dataQa?: string;
    gameId?: TwainGameId;
}

export const Select: React.FC<IProps> = (props) => {
    const t = translationProvider;
    return (
        <div className={classNames(classes.container, props.className)}>
            <select
                id={props.id}
                defaultValue={props.value ?? props.options[0]?.value}
                onChange={(e) => {
                    props.onChange(props.options[e.target.selectedIndex].value);
                }}
                className={classes.select}
                data-qa={props.dataQa}
            >
                {props.options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {t.stringByGame(option.name, props.gameId)}
                    </option>
                ))}
            </select>
            <span className={classes.iconWrapper}>
                <ChevronIcon direction={ChevronDirection.DOWN} className={classes.icon} />
            </span>
        </div>
    );
};
